import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Button } from 'react-aria-components';
import ListingFilterNew from '@/features/listing/components/listings-filters/listing-filter-new/listing-filter-new';
import styles from '@/features/listing/components/listings-filters/listing-type-filter/listing-type-filter.module.scss';
import { LISTINGS_SORT } from '@/features/listing/constants/listings-filters-constants';
import { type ListingsFilterName } from '@/features/listing/types/listing-filters-types';
import { useRouter } from '@/i18n/routing';
interface ListingSortProps {
  onFilterDisplayChange: (filterName: ListingsFilterName | null) => void;
  filterLink: {
    pathname: string;
    searchParams: URLSearchParams;
  };
}
export default function ListingSort(props) {
  const $ = _c(29);
  const {
    filterLink,
    onFilterDisplayChange
  } = props;
  const router = useRouter();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get(LISTINGS_SORT.name) ?? "LastActivity";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentValue = t0;
  const translationsFilterTitles = useTranslations("listing.filters.filter-titles");
  const translationsFilterSort = useTranslations("listing.filters.sort");
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  let t1;
  if ($[2] !== filterLink || $[3] !== onFilterDisplayChange || $[4] !== router) {
    t1 = value => () => {
      onFilterDisplayChange(null);
      setPopoverOpen(false);
      filterLink.searchParams.set(LISTINGS_SORT.name, value);
      router.push(`${filterLink.pathname}?${filterLink.searchParams.toString()}`);
    };
    $[2] = filterLink;
    $[3] = onFilterDisplayChange;
    $[4] = router;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleChange = t1;
  let T0;
  let t2;
  let t3;
  if ($[6] !== currentValue || $[7] !== translationsFilterSort || $[8] !== translationsFilterTitles) {
    let t4;
    if ($[12] !== currentValue) {
      t4 = sort => sort.value === currentValue;
      $[12] = currentValue;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    const currentSortOption = LISTINGS_SORT.options.find(t4);
    T0 = ListingFilterNew;
    if ($[14] !== translationsFilterTitles) {
      t2 = translationsFilterTitles("sort-by");
      $[14] = translationsFilterTitles;
      $[15] = t2;
    } else {
      t2 = $[15];
    }
    t3 = translationsFilterSort((currentSortOption?.label ?? "last-activity") as 'last-activity');
    $[6] = currentValue;
    $[7] = translationsFilterSort;
    $[8] = translationsFilterTitles;
    $[9] = T0;
    $[10] = t2;
    $[11] = t3;
  } else {
    T0 = $[9];
    t2 = $[10];
    t3 = $[11];
  }
  const t4 = `${t2}: ${t3}`;
  let t5;
  if ($[16] !== translationsFilterTitles) {
    t5 = translationsFilterTitles("sort-by");
    $[16] = translationsFilterTitles;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== currentValue || $[19] !== handleChange || $[20] !== translationsFilterSort) {
    t6 = LISTINGS_SORT.options.map(option => <Button key={option.value} className={styles.filterToggle} onPress={handleChange(option.value)} isDisabled={option.value === currentValue}>{translationsFilterSort(option.label)}</Button>);
    $[18] = currentValue;
    $[19] = handleChange;
    $[20] = translationsFilterSort;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== T0 || $[23] !== isPopoverOpen || $[24] !== onFilterDisplayChange || $[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t7 = <T0 buttonText={t4} dialogTitle={t5} onFilterDisplayChange={onFilterDisplayChange} listingFilterName="listingsSort" isPopoverOpen={isPopoverOpen} setPopoverOpen={setPopoverOpen}>{t6}</T0>;
    $[22] = T0;
    $[23] = isPopoverOpen;
    $[24] = onFilterDisplayChange;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
}